import { Outlet } from "react-router-dom";

const LWFMasterLayout = () => {
  return <Outlet />;
};

export default LWFMasterLayout;